export function getField(row, key) {
  switch (key) {
    case "fullName":
      return `${row?.name || ""} ${row?.lastname || ""}`.trim().toLowerCase();
    case "email":
      return (row?.email || "").toLowerCase();
    case "instagram":
      return (row?.instagram || "").toLowerCase();
    case "phone":
      return String(row?.phone || "");
    case "dni":
      return String(row?.dni || "");
    case "user_location":
      return (row?.user_location || "").toLowerCase();
    default:
      return row?.[key];
  }
}

export function descendingComparator(a, b, orderBy) {
  const av = getField(a, orderBy);
  const bv = getField(b, orderBy);
  if (bv < av) return -1;
  if (bv > av) return 1;
  return 0;
}

export function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// Packs helpers
export const formatCurrency = (value, currency) =>
  new Intl.NumberFormat("es-AR", {
    style: "currency",
    currency,
    maximumFractionDigits: currency === "ARS" ? 0 : 2,
  }).format(value ?? 0);

export const formatDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString("es-AR", { day: "2-digit", month: "2-digit" }) : "-";

export const isPackAvailable = (pack) => {
  const disabledByType = String(pack?.product?.type || "").toLowerCase() === "disabled";
  if (disabledByType) return false;
  const now = new Date();
  const membershipEnds = new Date(pack?.membership?.end ?? 0);
  const workshops = Array.isArray(pack?.workshops) ? pack.workshops : [];
  const hasOnSale = workshops.some((w) => w?.status === "onSale");
  return workshops.length > 0 ? hasOnSale : membershipEnds > now;
};

export const availabilityLabel = (pack) => {
  const disabledByType = String(pack?.product?.type || "").toLowerCase() === "disabled";
  if (disabledByType) return "Deshabilitado";
  return isPackAvailable(pack) ? "Disponible" : "No disponible";
};
